<script>
		import { user, game } from "../client.svelte.js"
		import {mapimg_URL} from "../core.js";

		let sections = $derived( // game.secttions.map(sectID => user.sections.get(sectID))
				user.sections.values()
					.filter(sect => sect.ADVT === view.adventure.ID)
					.map(sect => Object.assign({}, sect, {site: user.sites.get(sect.siteID ?? sect.ID) ?? null}))
					.toArray() )
		// $inspect(`STRUCTPANEL - sections`, sections)

		function select_section(e) {
				view.select_section(this)
		}
</script>

<!-------------------------------- HTML -------------------------------------->

<div class="sections-list">
	<div class="section" onclick={select_section.bind(null)}>
		<h2>Abenteuer {view.adventure.name}</h2>
	</div>

	{#each sections as section}
		<div class="section" onclick={select_section.bind(section)}>
			<h3>{section.name}</h3>
			{#if section.site}
				<img src={mapimg_URL(section.site)} alt={section.site.ID} >
			{/if}
		</div>
	{/each}
</div>


<!-------------------------------- STYLES -------------------------------------->

<style lang="sass">
	@use "../colors" as colors

	.sections-list
		display: flex
		flex-direction: column
		row-gap: 16px

	.section
		background: colors.$grey-20
		border-radius: 4px
		padding: 8px
		display: grid
		grid-template-columns: auto 144px
		row-gap: 16px

		img
			width: 128px
			max-height: 128px

</style>